import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/600.css";
import "@fontsource/hanken-grotesk/700.css";
import { scrubSentryEvent } from "@tinkr/shared/sentry-scrub";
import { App } from "./App";
import { applyDocumentLocale, detectInitialLocale } from "./i18n";
import "./styles.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENV ?? "dev",
    tracesSampleRate: 0,
    sendDefaultPii: false,
    initialScope: { tags: { service: "checkout" } },
    beforeSend: (event) => scrubSentryEvent(event)
  });
}

// Correct the static shell's default locale and direction before first paint;
// App keeps both attributes in sync on later switches.
const initialLocale = detectInitialLocale();
applyDocumentLocale(initialLocale);

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App initialLocale={initialLocale} />
  </StrictMode>
);
